import dayjs from "dayjs";
import { FC } from "react";
import {
  StoreMetadata,
  getEnvVar,
  getLogoFromMetadata } from
"@commons-monorepo/index";
import styles from "./store-verification-badge.module.css";

interface StoreVerificationBadgeProps {
  storeMetadata: StoreMetadata;
  storeVerifiedFrom?: string;
  lightMode?: boolean;
}

const StoreVerificationBadge: FC<StoreVerificationBadgeProps> = ({
  storeMetadata,
  storeVerifiedFrom,
  lightMode
}) => {
  const logo = getLogoFromMetadata(storeMetadata);
  const checkLogo = `${
  getEnvVar("PUBLIC_ENV") === "local" ? getEnvVar("PUBLIC_HOST") : ""
  }/prod/web/catalogue/verification-check-2.webp`;

  return !!storeVerifiedFrom ?
  <div className={styles.wrapper}>
      <figure className={styles.figure}>
        <img src={logo} alt='Store main logo' className={styles.img} />
        <img src={checkLogo} alt='Check' className={styles.check} />
      </figure>
      <div className={`${styles.texts}  ${lightMode && styles.lightTheme}`}>
        <div className={styles.title}>Tienda verificada</div>
        <div className={styles.until}>
          Desde {dayjs(storeVerifiedFrom).format("MMMM YYYY")}
        </div>
      </div>
    </div> :
  null;
};

export default StoreVerificationBadge;